// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"512":"e5853251","843":"260afc02","917":"579da529"}[chunkId] + ".chunk.css";
};